import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import getWhwAwards from "../../../../services/awards"
import { applyFilters } from "../../store/rankings.actions"
import { getActiveFilters } from "../../store/rankings.selectors"
import { AwardsCategoryFilterBox } from "../../styles"
import SelectInput from "../filters/selectInput"

const AwardsCategoryFilter = () => {
  const dispatch = useDispatch()
  const appliedFilters = useSelector(getActiveFilters)
  const [allAwards, setAllAwards] = useState()

  const handleSubmit = e => {
    dispatch(applyFilters({ award: e }))
  }

  useEffect(() => {
    async function loadAwards() {
      const res = await getWhwAwards()
      const mapped = res?.data?.awards?.map(({ name, label }) => ({
        id: name,
        name: label
      }))
      setAllAwards(mapped)
    }
    loadAwards()
  }, [setAllAwards])

  return (
    <AwardsCategoryFilterBox>
      <SelectInput
        options={{
          id: "filter-category",
          label: "Awards Winners",
          items: allAwards || []
        }}
        isLoading={allAwards?.isLoading}
        filterValue={appliedFilters.award}
        onFilter={handleSubmit}
      />
    </AwardsCategoryFilterBox>
  )
}

export default AwardsCategoryFilter
